"use strict";
/**
 * @packageDocumentation
 * @module Logger.Constants
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
var LoggerSettingBuilder_1 = require("../builder/LoggerSettingBuilder");
exports.settings = {
    datetime: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().withPrefix("[").withSuffix("]").get(),
    scope: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().withUnderline().withPrefix("[").withSuffix("]").get(),
    filename: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().withItalic().get(),
    seperator: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().get(),
    badge: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().get(),
    label: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().get(),
    message: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().get(),
    prefix: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().get(),
    suffix: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().get(),
    secret: LoggerSettingBuilder_1.LoggerSettingBuilder.initial().withPrefix("[").withSuffix("]").get(),
};
//# sourceMappingURL=settings.js.map